import { get, post, put } from "./http";

// Mirrors ordr-flutter Repository dwolla/* + buyer bank calls
export const createDwollaBusinessAccount = (payload) => post("/dwolla/create-dwolla-business-account", payload);
export const updateDwollaBusinessAccount = (payload) => post("/dwolla/update-dwolla-business-account", payload);
export const addBeneficialOwner = (payload) => post("/dwolla/add-beneficial-owner", payload);
export const updateBeneficialOwner = (id, payload) => post(`/dwolla/update-beneficial-owner/${id}`, payload);
export const getBeneficialOwnerList = () => get("/dwolla/get-beneficial-owner-list");
export const getDwollaUserInfo = () => get("/dwolla/get-dwolla-user-info");
export const getCompanyDetails = () => get("/dwolla/get-company-details");
export const updateCompanyDetails = (payload) => put("/dwolla/update-company-details", payload);
export const certifiedDwollaUser = () => get("/dwolla/certified-dwolla-user");
export const getBuyerStatusList = () => get("/dwolla/get-buyer-status-list");

export const addBuyerBank = (payload) => post("/buyer/bank", payload);
// payload: { bankName, accountNumber, routing }

export const createFundingSource = (payload) => post("/dwolla/create-funding-source", payload);
export const createFundingSourcePlaid = (payload) => post("/dwolla/create-funding-source-plaid", payload);
export const deleteBankAccount = (payload) => post("/dwolla/delete-bank-account", payload);
export const getFundingSourceList = () => get("/dwolla/get-funding-source-list");
export const getVerifiedBankList = () => get("/dwolla/get-verified-bank-list");
export const getOnDemandAuthorizations = () => get("/dwolla/get-on-demand-authorizations");

export const plaidCreateTokenNew = (payload) => post("/dwolla/plaid-create-token-new", payload);
export const plaidCreateProcessor = (payload) => post("/dwolla/plaid-create-processor", payload);
export const plaidExchangeToken = (payload) => post("/dwolla/plaid-exchange-token", payload);
export const plaidMicroDepositStatus = (payload) => post("/dwolla/plaid-micro-deposit-status", payload);
export const verifyMicroDeposits = (payload) => post("/dwolla/verify/micro/deposits", payload);

export const transferAmount = (payload) => post("/dwolla/transfer-amount", payload);
export const getDwollaBalance = () => get("/dwolla/get-dwolla-balance");
export const getTransferList = () => get("/dwolla/get-transfer-list");

export const uploadDocuments = (formData) => post("/dwolla/upload-documents", formData, { "Content-Type": "multipart/form-data" });
export const uploadBeneficialDocuments = (formData) =>
	post("/dwolla/upload-beneficial-user-documents", formData, { "Content-Type": "multipart/form-data" });
